import { PayloadAction } from '@reduxjs/toolkit'
import { CampaignKey, VoucherSliceState, CreateCampaignKey } from 'src/core/models'
import { initialState } from './state'
import { CreateDiscountVoucherKey } from 'src/core/models/vouchers.types'

const reducers = {

  // Campaign List
  setCampaignValue: (state: VoucherSliceState, action: PayloadAction<CampaignKey>) => {
    state.campaings[String(action.payload.key)] = action.payload.value
  },
  resetCampaignsState: (state: VoucherSliceState) => {
    state.campaings = initialState.campaings
  },

  // Create Campaign
  setCreateCampaignValue: (state: VoucherSliceState, action: PayloadAction<CreateCampaignKey>) => {
    state.createCampaign[String(action.payload.key)] = action.payload.value
  },
  resetCreateCampaignsState: (state: VoucherSliceState) => {
    state.createCampaign = initialState.createCampaign
  },

  // Create Discount Voucher
  setCreateDiscountVoucheralue: (state: VoucherSliceState, action: PayloadAction<CreateDiscountVoucherKey>) => {
    state.createDiscountVoucher[String(action.payload.key)] = action.payload.value
  },
  resetCreateDiscountVoucherState: (state: VoucherSliceState) => {
    state.createDiscountVoucher = initialState.createDiscountVoucher
  },
}

export default reducers
